var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isOpen
        ? _c(
            "modal",
            {
              attrs: {
                "cancel-text": "Cerrar",
                icon: "fa-search",
                show: true,
                "show-save": false,
                "show-top-close": "",
                title: "Detalle de Visitas",
                width: "50%"
              },
              on: {
                cancel: function($event) {
                  return _vm.$emit("onClose")
                }
              }
            },
            [
              _vm._l(_vm.itemsPaginated, function(item, idx) {
                return _c(
                  "div",
                  {
                    key: `${item.visitTypeName}${idx}`,
                    staticClass: "row mb-2 bg-secondary-3 mx-4"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-12",
                        class: _vm.showReason(item.visitTypeId)
                          ? "col-md-6"
                          : "col-md-12"
                      },
                      [
                        _c("span", { staticClass: "data-label" }, [
                          _vm._v("Tipo:")
                        ]),
                        _c("p", { staticClass: "data" }, [
                          _vm._v(_vm._s(_vm.infoDisplay(item).visitTypeName))
                        ])
                      ]
                    ),
                    _vm.showReason(item.visitTypeId)
                      ? _c("div", { staticClass: "col-6" }, [
                          _c("span", { staticClass: "data-label" }, [
                            _vm._v("Razón:")
                          ]),
                          _c("p", { staticClass: "data" }, [
                            _vm._v(_vm._s(_vm.infoDisplay(item).justification))
                          ])
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "col-12 col-md-6" }, [
                      _c("span", { staticClass: "data-label" }, [
                        _vm._v("Fecha:")
                      ]),
                      _c("p", { staticClass: "data" }, [
                        _vm._v(_vm._s(item.visitDateFormat))
                      ])
                    ]),
                    _c("div", { staticClass: "col-12 col-md-6" }, [
                      _c("span", { staticClass: "data-label" }, [
                        _vm._v("Horario:")
                      ]),
                      _c("p", {
                        staticClass: "data",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.setBoldMinutes(item.completeTime)
                          )
                        }
                      })
                    ])
                  ]
                )
              }),
              _vm.items.length > _vm.count
                ? _c("pagination", {
                    attrs: { data: _vm.pagination },
                    on: {
                      "pagination-go-page": function($event) {
                        _vm.currentPage = $event
                      }
                    }
                  })
                : _vm._e(),
              _vm.items.length == 0 ? _c("result-not-found") : _vm._e()
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }